import { useEffect } from 'react';
import { Button } from './Button';
import './ui.css';

/**
 * Modal confirmation. Used where a mutation needs a conscious decision (buffer override,
 * cancel + refund) — never for routine success/failure, which stays in toasts.
 */
export function ConfirmDialog({
  title,
  body,
  confirmLabel,
  danger = false,
  busy = false,
  onConfirm,
  onCancel,
  children,
}: {
  title: string;
  body?: string;
  confirmLabel: string;
  danger?: boolean;
  busy?: boolean;
  onConfirm: () => void;
  onCancel: () => void;
  children?: React.ReactNode;
}) {
  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onCancel();
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [onCancel]);

  return (
    <div className="ui-dialog-backdrop" role="presentation" onClick={onCancel}>
      <div
        className="ui-dialog"
        role="alertdialog"
        aria-modal="true"
        aria-label={title}
        onClick={(e) => e.stopPropagation()}
      >
        <h2 className="ui-dialog-title">{title}</h2>
        {body ? <p className="ui-dialog-body">{body}</p> : null}
        {children}
        <div className="ui-dialog-actions">
          <Button variant="secondary" onClick={onCancel} disabled={busy}>
            Keep as is
          </Button>
          <Button
            autoFocus
            variant={danger ? 'danger' : 'primary'}
            onClick={onConfirm}
            loading={busy}
          >
            {confirmLabel}
          </Button>
        </div>
      </div>
    </div>
  );
}
